import Card from "@/components/card";
import { CardDetail } from "@/components/card-details";
import CardSkeleton from "@/components/skeletons/card-skeleton";
import { Button } from "@/components/ui/button";
import { useGetCards } from "@/hooks/use-queries";
import { useCardsStore } from "@/zustand/store";
import { AnimatePresence } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";

const SelectCard = () => {
  const navigate = useNavigate();
  const { isCardDetailsOpen } = useCardsStore((state) => state);
  const { data: cards, isLoading } = useGetCards();

  return (
    <div>
      {/* header */}
      <header className="flex items-center justify-between">
        <div>
          <p className="text-lg font-semibold">Select Card</p>
          <p className="leading-4">
            Choose the card you want to view the history of
          </p>
        </div>
      </header>
      {isLoading ? (
        <div className="mt-6 grid w-full grid-cols-1 place-items-center gap-4 md:grid-cols-2 lg:grid-cols-3">
          {[1, 2, 3].map((_, index) => (
            <CardSkeleton key={index} />
          ))}
        </div>
      ) : cards?.data.length === 0 ? (
        <div className="w- flex h-100 items-center justify-center">
          <div className="flex flex-col text-center">
            <h2 className="text-2xl font-bold">No Cards</h2>
            <p className="text-primary-500/40">
              Instantly create a card to start making transactions
            </p>

            <div className="mt-4">
              <Button
                className="w-full"
                onClick={() => {
                  navigate("/dashboard/shop");
                }}
              >
                Create Card
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div className="relative mt-12 grid w-full grid-cols-1 place-items-center gap-4 lg:mt-6 lg:grid-cols-3">
          {cards?.data.map((card: Card, index: number) => (
            <Link
              key={index}
              className="w-full"
              to={"/dashboard/account/card-history/" + card.id}
            >
              <Card key={index} card={card} showCta={false} />
            </Link>
          ))}
        </div>
      )}
      <AnimatePresence mode="wait">
        {isCardDetailsOpen && <CardDetail />}
      </AnimatePresence>
    </div>
  );
};

export default SelectCard;
